import React from "react";

const englishMasses = [
  ["Sunday", "07.30 am", "English"],
  ["Wednesday", "06.30 pm", "English"],
  ["Saturday", "04.00 pm", "English"],
];

const tamilSundayMasses = [
  "காலை 06.00 - தமிழ்",
  "காலை 07.30 - ஆங்கிலம்",
  "காலை 08.30 - தமிழ்",
  "மாலை 05.30 - தமிழ்",
];

const tamilWeekdayMasses = [
  "காலை 06.15 - தமிழ்",
  "மாலை 06.30 - தமிழ்",
];

const specialDevotions = [
  "First Friday: 06.30 pm Mass followed by one hour Adoration",
  "Every Saturday: Divine Mercy Devotion with Mass from 02.30 pm to 05.00 pm",
  "Every Month: First Sunday devotion to God our Loving Father with Mass from 03.00 pm to 05.00 pm",
  "15th to 23rd: Novena to Mary Help of Christians",
  "24th: 06.30 pm Mass and Procession",
  "Last Day: Commemoration of St. John Bosco, 06.30 pm Mass and Procession",
];

const tamilSpecialDevotions = [
  "முதல் வெள்ளிக்கிழமை மாலை 06.30 மணிக்கு திருப்பலி, ஒரு மணி நேர நற்கருணை ஆராதனை.",
  "ஒவ்வொரு சனிக்கிழமை காலை 08.30 முதல் 01.30 மணிவரை திருப்பலியுடன் உபவாச செபக்கூட்டம்",
  "ஒவ்வொரு மாதம் 1ம் தேதி 03 முதல் 29 வரை இறைவினாரருக்கண்வை நவநாள்,",
  "ஒவ்வொரு மாதம் 06.30 மணிக்கு திருப்பலி, தேர்ப்றாணி",
  "24 ஆம் தேதி மாலை 06.30 மணிக்கு திருப்பலி, ஜேபப் போணி நினைவு நாள்",
  "ஒவ்வொரு மாத இறுதி நாள் - பதிது இபேசு அப்போஸ்தலர், தேர்பமணி மாலை 06.30 மணிக்கு திருப்பலி, ஜேப்றற ஆராதனைவும், தேர்பயணி",
];

const MassTime = () => {
  return (
    <div className="col-lg-12 mb-3">
      <div className="section-title text-center">
        <h4 className="our-title">Mass Timings</h4>
      </div>
      <div className="timeline container">
        <div className="row">
          <div className="col-lg-6">
            <div className="event mass-dates">
              <div className="event-icon event-icon-weekdays">
                <i className="fa fa-calendar" />
              </div>
              <div className="event-details" title="Masses in English">
                <h5 className="mb-4">Masses in English</h5>
                {englishMasses.map(([day, time, language]) => (
                  <p key={day}>
                    <strong>{day}</strong> : {time} {language}
                  </p>
                ))}
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="event mass-dates">
              <div className="event-icon event-icon-sundays">
                <i className="flaticon-college" />
              </div>
              <div className="event-details" title="Masses in Tamil">
                <h5 className="mb-4">Masses in Tamil</h5>

                <h6>ஞாயிறு திருப்பலிகள்</h6>
                {tamilSundayMasses.map((mass) => (
                  <p key={mass}>{mass}</p>
                ))}

                <br />
                <h6>வாரநாள் திருப்பலிகள்</h6>
                {tamilWeekdayMasses.map((mass) => (
                  <p key={mass}>{mass}</p>
                ))}
              </div>
            </div>
          </div>

          <div className="col-lg-12 mt-4">
            <div className="event mass-dates">
              <div className="event-icon event-icon-weekdays">
                <i className="fa fa-church" />
              </div>
              <div className="event-details" title="Special Devotions">
                <h5 className="mb-4">சிறப்பு நிகழ்ச்சிகள்</h5>
                {tamilSpecialDevotions.map((devotion) => (
                  <p key={devotion}>{devotion}</p>
                ))}

                <br />
                <h5 className="mb-4">Special Devotions</h5>
                {specialDevotions.map((devotion) => (
                  <p key={devotion}>{devotion}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MassTime;
